"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Scrollbars = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _primitives = require("../primitives");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    border-radius: 8px;\n    background: ", ";\n  }\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 8px;\n  }\n  & > * {\n    &::-webkit-scrollbar {\n      width: 8px;\n      height: 8px;\n      border-radius: 8px;\n      background: ", ";\n    }\n    &::-webkit-scrollbar-thumb {\n      background: ", ";\n      border-radius: 8px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Scrollbars = (0, _styledComponents.default)(_primitives.Box)(_templateObject(), function (props) {
  return (0, _styledSystem.themeGet)("colors." + props.scrollbar)(props);
}, function (props) {
  return (0, _styledSystem.themeGet)("colors." + props.thumb)(props);
}, function (props) {
  return (0, _styledSystem.themeGet)("colors." + props.scrollbar)(props);
}, function (props) {
  return (0, _styledSystem.themeGet)("colors." + props.thumb)(props);
});
exports.Scrollbars = Scrollbars;
Scrollbars.defaultProps = {
  scrollbar: 'blue.light',
  thumb: 'blue.dark'
};